export default __webpack_public_path__ + "static/media/qr-code.ab0084ef.png";